import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import Login from "./login/Login";
import { useEffect } from "react";
import { GameModeEnum } from "../../types/gameModeEnum";
import Lobby from "./lobby/Lobby";
import { setGameMode } from "../../store/gameSlice";
import Day from "./Day";
import Night from "./Night";
import './Game.scss';
import Dead from "./Dead";
import End from "./End";

function Game() {    
    const dispatch = useDispatch();
    const { loggedIn } = useSelector((state: RootState) => state.general);
    const { gameMode } = useSelector((state: RootState) => state.game);

    useEffect(() => {
        if(process.env.REACT_APP_DEV_MODE === 'true') {
            dispatch(setGameMode(GameModeEnum.Day));
        }
        else if(!loggedIn){
            dispatch(setGameMode(GameModeEnum.Login));
            return;
        }
    }, [loggedIn]);

    switch (gameMode) {
        case GameModeEnum.Lobby:
            return <Lobby />
        case GameModeEnum.Day:
            return <Day />
        case GameModeEnum.Night:
            return <Night />
        case GameModeEnum.Dead:
            return <Dead />
        case GameModeEnum.End:
            return <End />
        case GameModeEnum.Login:
        default:
            return <Login />
    }
}

export default Game;